import { api } from "./configs/axiosConfigs";

export const ReportAPI = {
  getMemberActivityReport: (
    start_date = "2024-11-30",
    end_date = "2050-01-01",
  ) => {
    return api.get(
      `/reports/member_activity_report?start_date=${start_date}&end_date=${end_date}&order_by=total_points_received&order=desc`,
    );
  },
  getCloseBusinessReport: (
    start_date = "2024-11-30",
    end_date = "2050-01-01",
  ) => {
    return api.get(
      `/reports/closed_business_report?start_date=${start_date}&end_date=${end_date}&order_by=closed_business_date&order=desc`,
    );
  },

  getOverallActivityReport: (
    start_date = "2024-11-30",
    end_date = "2050-01-01",
  ) => {
    return api.get(
      `/reports/overall_activity_report?start_date=${start_date}&end_date=${end_date}`,
    );
  },

  getMembersCloseBusinessReport: (
    start_date = "2024-11-30",
    end_date = "2050-01-01",
    type,
    memberId,
  ) => {
    return api.get(
      `/members/${memberId}/reports/closed_business_report?start_date=${start_date}&end_date=${end_date}&order_by=closed_business_date&order=desc${type}`,
    );
  },

  getMemberIndividualReport: (memberId) => {
    return api.get(`/reports/member_report/${memberId}`);
  },

  getMemberActivityFeed: (
    memberId,
    start_date = "0001-01-01",
    end_date = "9999-01-01",
  ) => {
    return api.get(
      `/reports/member_activity_feed/${memberId}?start_date=${start_date}&end_date=${end_date}`,
    );
  },
};
